import React from 'react';
import ReactDOM from 'react-dom';
import formInfoStorage from "./FormInfoStorage";
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "mobx-react";
import 'bootstrap/dist/css/bootstrap.min.css';


const Root = (
  <Provider FormInfoStorage={formInfoStorage}>
      <App />
  </Provider>
);

ReactDOM.render(Root, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
